import useSearchParamGroup from "ui/common/hooks/useSearchParamGroup";

export default function usePartnersFilters() {
    return useSearchParamGroup(["query", {}]);
}
